// skeleton/app/src/app/siteminder-login/siteminder-login.component.ts

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../shared/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../auth/auth.service';
import { LogoutServive } from '../logout/logout.service';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { NotificationService } from '../shared/services/notifications.service';
import { TokenStorageService } from '../shared/services/token-storage.service';
import { SiteminderAuthService } from '../auth/oidc-config.service';

import { Observable, Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GroupMappingDialogComponent } from '../login/group-mapping-dialog/group-mapping-dialog.component';
import { UserServiceService } from '../user/survey-main/service/user-service.service';
import { MenubarService } from '../shared/services/menunavbar.services';

@Component({
  selector: 'app-siteminder-login',
  templateUrl: './siteminder-login.component.html',
  styleUrl: './siteminder-login.component.scss',
  standalone: false,
})
export class SiteminderLoginComponent implements OnInit, OnDestroy {
  siteminderToken: string = '';
  UserLoggedIn: boolean = false;
  constants: Constants = new Constants();
  routeSubScription: any;
  userClaims: any;

  private readonly LOGOUT_FLAG_KEY = 'siteminder_force_logout';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: SiteminderAuthService,
    private notificationService: NotificationService,
    private globalsessionhandler: GlobalsessionhandlerService,
    private spinnerService: NgxSpinnerService,
    private tokenStorage: TokenStorageService,
    private loginauthService: AuthService,
    private logoutservice: LogoutServive,
    private dialog: MatDialog,
    private userService: UserServiceService,
    private menubarService: MenubarService,
    private baseHttpService: BaseHttpService
  ) {}

  async ngOnInit() {
    await this.checkUserSession();
  }

  private isLogoutGuardOn(): boolean {
    try {
      const ss = sessionStorage.getItem(this.LOGOUT_FLAG_KEY);
      const ls = localStorage.getItem(this.LOGOUT_FLAG_KEY);
      return ss === '1' || ls === '1';
    } catch {
      return false;
    }
  }

  private clearLogoutGuard(): void {
    try {
      sessionStorage.removeItem(this.LOGOUT_FLAG_KEY);
    } catch {}

    try {
      localStorage.removeItem(this.LOGOUT_FLAG_KEY);
    } catch {}
  }

  async checkUserSession() {
    try {
      // If SiteMinder sends access_denied, STOP auto-login to prevent infinite loop
      const error = (
        this.route.snapshot.queryParamMap.get('error') || ''
      )
        .toString()
        .trim()
        .toLowerCase();

      const loggedOutFlag =
        this.route.snapshot.queryParamMap.get('loggedout') === '1';

      if (error === 'access_denied') {
        try {
          this.spinnerService.hide();
        } catch {}

        // IMPORTANT: keep guard ON here so app does not keep re-trying login
        return;
      }

      if (this.isLogoutGuardOn()) {
        this.clearLogoutGuard();
      }

      // If coming from IdP logout redirect, allow login flow again
      if (loggedOutFlag) {
        this.clearLogoutGuard();
      }

      // If not logged in, start SiteMinder login flow
      if (!this.authService.isLoggedIn()) {
        try {
          this.spinnerService.show();
        } catch {}

        this.authService.startTokenRefreshInterval();
        await this.authService.loginoidc();
        return;
      }

      await this.siteminder();
    } catch (e) {
      try {
        this.spinnerService.hide();
      } catch {}

      this.router.navigate(['/login']);
    }
  }

  navigateToUserActivity() {
    this.router.navigate(['/reports']);
  }

  get accessToken(): string {
    return this.authService.getValidAccessToken();
  }

  ngOnDestroy() {
    this.routeSubScription?.unsubscribe();
  }

  async loadAccessPermission() {
    this.globalsessionhandler.clearSession();
  }

  async siteminder() {
    this.spinnerService.show();

    try {
      this.userClaims = this.authService.getValiClaims();

      sessionStorage.setItem(
        'siteminderAccessToken',
        this.authService.getValidAccessToken()
      );

      sessionStorage.setItem(
        'siteminderIdToken',
        this.authService.getValidIdToken()
      );

      sessionStorage.setItem(
        'token',
        this.authService.getValidIdToken()
      );

      sessionStorage.setItem(
        'cognitorefreshToken',
        this.authService.getValidAccessToken()
      );

      const creationResult = await this.GetOrCreateUser();

      if (creationResult != null) {
        sessionStorage.setItem(
          'LoggedInUserAgencyId',
          creationResult['agencyId']
        );
      }

      if (creationResult === false) {
        this.spinnerService.hide();
        return;
      }

      this.isUserHasGroupMapping().subscribe(
        (mapAvailable: boolean) => {
          if (!mapAvailable) {
            this.openGroupmappingDialog();
            this.spinnerService.hide();
            return;
          }

          this.loadAccessPermission().then(() => {
            this.globalsessionhandler.emitloginSucessful(true);

            this.baseHttpService
              .get(this.constants.getUser)
              .subscribe(
                (result: any) => {
                  if (result != null) {
                    this.userService.getUserDeatils(result);

                    const loginname = (result.fullName || '').split(',');

                    sessionStorage.setItem(
                      'LoggedInuserId',
                      JSON.stringify(result.customerId)
                    );

                    sessionStorage.setItem(
                      'LoggedInuserMailId',
                      result.email
                    );

                    sessionStorage.setItem(
                      'LoggedInUserTypeId',
                      result.userTypeId
                    );

                    sessionStorage.setItem(
                      'LoggedInUserTypeDesc',
                      result.userTypeDesc
                    );

                    sessionStorage.setItem(
                      'LoggedInuserFirstName',
                      loginname?.[1] ?? ''
                    );

                    sessionStorage.setItem(
                      'LoggedInUserAgency',
                      result.userAgency
                    );

                    sessionStorage.setItem(
                      'LoggedInProviderType',
                      result.providerType
                    );

                    const first = (loginname?.[1] || '').trim();
                    const last = (loginname?.[0] || '').trim();

                    if (first || last) {
                      this.globalsessionhandler.setLoggedInUserName(
                        `${first}, ${last}`.trim()
                      );
                    }

                    this.globalsessionhandler.setUserGroupId(
                      result.userGroupId
                    );

                    sessionStorage.setItem(
                      'UserGroupId',
                      result.userGroupId
                    );

                    this.UserLoggedIn = true;

                    this.logoutservice.changeMessage(
                      this.UserLoggedIn
                    );

                    this.menubarService.updatedDataSelection(true);

                    this.logoutservice.setCognitoUserLoginStatus(
                      true
                    );

                    this.router.navigate(['/homePage']);
                  }

                  this.spinnerService.hide();
                },
                () => {
                  this.spinnerService.hide();
                }
              );
          });
        },
        () => {
          this.spinnerService.hide();
        }
      );
    } catch (apiErr) {
      this.spinnerService.hide();

      this.notificationService.showError(
        'User account is logged due to invalid login attempts. Please try after 15 minutes.',
        'Login failed'
      );

      this.router.navigate(['/login']);
      return;
    }
  }

  async GetOrCreateUser() {
    return new Promise<any>((resolve) => {
      this.baseHttpService
        .get(this.constants.GetOrCreateUser)
        .subscribe(
          (result) => resolve(result ?? false),
          (error) => {
            if (
              error?.status === 401 ||
              error?.status === 403
            ) {
              this.notificationService.showError(
                'You are not authorized to access this application.Please contact your Admin',
                'Unauthorized Access'
              );

              resolve(false);
              return;
            }

            resolve(false);
          }
        );
    });
  }

  isUserHasGroupMapping(): Observable<boolean> {
    const subject = new Subject<boolean>();

    const email = (
      this.userClaims?.email || ''
    )
      .toString()
      .trim();

    if (!email) {
      subject.next(false);
      subject.complete();

      return subject.asObservable();
    }

    this.baseHttpService
      .getById(
        this.constants.getUserGroupMapping,
        email
      )
      .subscribe(
        (result: boolean) => {
          subject.next(result);
          subject.complete();
        },
        (error) => subject.error(error)
      );

    return subject.asObservable();
  }

  logout() {
    this.authService.logout();
  }

  openGroupmappingDialog() {
    const dialogRef = this.dialog.open(
      GroupMappingDialogComponent,
      {
        width: '400px',
        height: '300px',
      }
    );

    dialogRef.afterClosed().subscribe(() => {});
  }
}